import SquatRackSide from '../assets/images/free-weight-room17-600w.avif'
import GymInsideMedium from '../assets/images/machine-room1-600w.avif'
import MachineRoom from '../assets/images/machine-room3-600w.avif'
import DeadliftStation from '../assets/images/free-weight-room6-600w.avif'
import FreeWeightRoom from '../assets/images/free-weight-room7-600w.avif'
import Gym5846 from '../assets/images/gym-5846-1200w.avif'
import Gym5837 from '../assets/images/gym-5837-1200w.avif'
import Gym5742 from '../assets/images/gym-5742-1200w.avif'
import CardioRoom from '../assets/images/cardio-room3-600w.avif'

import { Link } from 'react-router-dom'
import HeadingOne from '../components/HeadingOne';
import HeadingTyping from '../components/HeadingTyping';
import React, { useEffect } from 'react';

const ConceptPage = () => {
    useEffect(() => {
        document.title = `Het Concept Uitgelegd - Private Gym Schijndel`;
    }, []);

    return (
        <>
            <section className="hero concept-hero">
                <div className="default-container flex justify-center items-center h-full w-full">
                    <div className="text-center">
                        <HeadingOne>Het concept uitgelegd.</HeadingOne>
                        <h3 className="text-primary-500 pt-2 pb-16">Alle voordelen van Private Gym Schijndel.</h3>
                    </div>
                </div>
            </section>

            {/* Intro black card */}
            <section className="bg-white">
                <div className="default-container">
                    <div className="black-card max-w-3xl">
                        <p className="text-xs font-semibold tracking-widest uppercase text-primary-400 pb-3">Het concept</p>
                        <h2 className="text-white pb-4">Een exclusieve trainingsomgeving.</h2>
                        <hr className="primary-hr mb-8"/>
                        <p className="text-gray-300 pb-8">Train in volledige privacy, zonder drukte, zonder wachten en zonder afleiding. Alleen jij en je doelen, in een rustige omgeving met hoogwaardig materiaal en een persoonlijk trainingsplan.</p>
                        <Link to={'/rooms'} className="primary-button">Bekijk de gym</Link>
                    </div>
                </div>
            </section>

            {/* 3 feature cards on black */}
            <section className="bg-black pb-52 pt-16">
                <div className="default-container">
                    <HeadingTyping className="text-3xl md:text-6xl tracking-wider pb-16 text-white">
                        Focus op uw eigen doel.
                    </HeadingTyping>
                    <div className="grid-three-sections -mb-52">
                        <div className="bg-white shadow-2xl rounded overflow-hidden">
                            <img className="object-cover h-52 w-full" src={DeadliftStation} alt="Free weight" loading="lazy"/>
                            <div className="p-8">
                                <h4>Sterk</h4>
                                <hr className="primary-hr mb-4"/>
                                <p>Werk doelgericht aan meer kracht en spiermassa met een persoonlijk trainingsplan afgestemd op jouw niveau en doelen.</p>
                            </div>
                        </div>

                        <div className="bg-white shadow-2xl rounded overflow-hidden">
                            <img className="object-cover h-52 w-full" src={SquatRackSide} alt="Squat rack" loading="lazy"/>
                            <div className="p-8">
                                <h4>Onbeperkt</h4>
                                <hr className="primary-hr mb-4"/>
                                <p>Bij Private Gym Schijndel ervaar je onbeperkt sporten in volledige privacy. Geen drukte, geen afleiding — alleen jij en je doelen. Elke dag van het jaar van <span className="font-semibold text-primary-500">7.00 tot 22.00</span> beschikbaar.</p>
                            </div>
                        </div>

                        <div className="bg-white shadow-2xl rounded overflow-hidden">
                            <img className="object-cover h-52 w-full" src={GymInsideMedium} alt="Krachtmachines" loading="lazy"/>
                            <div className="p-8">
                                <h4>Deskundige begeleiding</h4>
                                <hr className="primary-hr mb-4"/>
                                <p>Begeleiding vanuit jarenlange praktijkervaring en wetenschappelijke expertise op het gebied van krachttraining, gezondheid en belastbaarheid.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Gradient banner */}
            <section className="pt-52">
                <div className="bg-gradient-to-r from-primary-900 via-primary-700 to-primary-500">
                    <div className="default-container flex flex-col space-y-6 items-start md:items-center text-left md:text-center">
                        <p className="text-xs font-semibold tracking-widest uppercase text-primary-300">Standaard inbegrepen</p>
                        <h2 className="text-3xl md:text-5xl tracking-wider text-white">Een persoonlijk trainingsplan. Altijd.</h2>
                        <p className="text-gray-300 max-w-xl">Een trainingsplan op maat is bij ieder lidmaatschap standaard inbegrepen — geen extra kosten, geen losse afspraken.</p>
                        <Link to={'/membership'} className="primary-button">Bekijk de lidmaatschappen</Link>
                    </div>
                </div>
            </section>

            {/* Het beste materiaal */}
            <section className="bg-white">
                <div className="default-container">
                    <div className="flex flex-col-reverse md:flex-row items-center gap-8 md:gap-16">
                        <div className="flex flex-col space-y-4 w-full md:w-3/5">
                            <div className="h-48 w-full shadow-xl rounded zoom overflow-hidden">
                                <img className="object-cover h-full w-full" src={CardioRoom} alt="Cardio" loading="lazy"/>
                            </div>
                            <div className="h-48 w-full shadow-xl rounded zoom overflow-hidden">
                                <img className="object-cover h-full w-full" src={MachineRoom} alt="Krachtmachines" loading="lazy"/>
                            </div>
                            <div className="h-48 w-full shadow-xl rounded zoom overflow-hidden">
                                <img className="object-cover h-full w-full" src={FreeWeightRoom} alt="Free weight" loading="lazy"/>
                            </div>
                        </div>
                        <div className="w-full md:w-2/5">
                            <p className="text-xs font-semibold tracking-widest uppercase text-primary-500 pb-3">De gym</p>
                            <h2 className="text-3xl md:text-5xl tracking-wider pb-4">Het beste materiaal.</h2>
                            <hr className="primary-hr mb-8"/>
                            <p>Bij Private Gym Schijndel staat kwaliteit centraal. Maak gebruik van hoogwaardige trainingsmaterialen voor krachttraining, cardio en vrije gewichten — zodat trainen effectief én prettig blijft.</p>
                            <Link to={'/rooms'} className="primary-button mt-8 inline-block">Bekijk de gym</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="bg-black">
                <div className="default-container text-center flex flex-col justify-center items-center">
                    <h2 className="text-white">Klaar voor een gezondere leefstijl?</h2>
                    <p className="pt-4 pb-12 text-gray-300">Bekijk welke mogelijkheid het beste bij jou past.</p>
                    <Link to={'/membership'} className="primary-button">Bekijk de mogelijkheden</Link>
                </div>
            </section>

            {/* Staggered image gallery */}
            <section className="bg-white py-8 md:py-24">
                <div className="default-container flex justify-center items-center">
                    <div className="flex items-end gap-4 max-w-5xl w-full">
                        <div className="h-[480px] w-full shadow-xl rounded zoom overflow-hidden">
                            <img className="object-cover h-full w-full" src={Gym5846} alt="Private Gym Schijndel" loading="lazy"/>
                        </div>
                        <div className="h-[580px] w-full shadow-xl rounded zoom overflow-hidden">
                            <img className="object-cover h-full w-full" src={Gym5742} alt="Private Gym Schijndel" loading="lazy"/>
                        </div>
                        <div className="h-[420px] w-full shadow-xl rounded zoom overflow-hidden">
                            <img className="object-cover h-full w-full" src={Gym5837} alt="Private Gym Schijndel" loading="lazy"/>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ConceptPage;
